<template>
  <v-btn
    v-if="isVisible"
    data-qa="leave_rate_btn"
    class="bg-lpu-branding-color-primary rounded-20"
    :ripple="{ class: 'bg-lpu-branding-color-primary--text' }"
    depressed
    height="52"
    @click="openNewRateForm"
  >
    <div class="bg-gray-0--text">
      {{ tStatic('Оставить отзыв') }}
    </div>
  </v-btn>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import canLeaveReview from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/canLeaveReview'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import type { CommonContextStore } from 'src/types/context'
import useContextStore from 'src/store/useContextStore'
import useURLStore from 'src/store/useURLStore'
import useYandexGoals from 'src/composables/useYandexGoals'

const props = defineProps<{
  lpuId: number
  isClosed: boolean
}>()

const { context, urlLang }: CommonContextStore = useContextStore()
const { reverseFullL10N } = useURLStore()
const { sendYaGoal } = useYandexGoals()

const isVisible = computed(() => canLeaveReview(context, props.isClosed))

const newRateFormUrl = reverseFullL10N({
  name: 'newrate_lpu',
  args: {
    language: urlLang,
    object_id: String(props.lpuId),
  },
})

function openNewRateForm() {
  sendYaGoal('click_leave_review_free')
  window.location.assign(newRateFormUrl)
}
</script>
